import React from 'react';

import { Typography } from 'antd';
import styled from 'styled-components';

const { Paragraph } = Typography;

const Text = styled(Paragraph)`
  font-size: 14px;
  color: var(--text-secondary);
  white-space: break-spaces;
`;

const EllipsisSymbol = styled.span`
  color: var(--dark-blue);
  cursor: pointer;
`;

interface Props {
  text: string;
}

const ShopNotesSingleParagraphText = ({ text }: Props) => {
  return (
    <Text
      style={{ marginBottom: 0 }}
      ellipsis={{
        rows: 4,
        expandable: 'collapsible',
        symbol: (expanded: boolean) => <EllipsisSymbol>{expanded ? 'Show Less' : 'Show More'}</EllipsisSymbol>,
      }}
    >
      {text}
    </Text>
  );
};

export default ShopNotesSingleParagraphText;
